<script>
  import { onMount } from "svelte";
  import { writable } from "svelte/store";
  import Particles, { particlesInit } from "@tsparticles/svelte";
  import { loadFull } from "tsparticles"; // if you are going to use `loadFull`, install the "tsparticles" package too.
  import { get } from "svelte/store";

  let confettiContainer;
  let showParticles = false;
  const txt =
    "Hello! I'm Fatima, a UX designer & user researcher based in London 🦦";
  const speed = 50;
  let i = 0;
  let bio = "";
  let activeSection = null; // Start with no active section
  let bioVisible = false;
  let isBio = true; // Include this if needed for bio section visibility
  let isAbout = false;
  let isContact = false;
  let fadeInElements = false; // New variable
  let selectedProject = null; // Store the selected project
  let viewMode = "all"; // Possible values: 'all', 'project'
  // let currentPage = null;

  let isCVButtonActive = false;

  let projectOverview = false;
  let projectDetails = false;
  let projectTldr = false;

  function showProjectOverview() {
    projectOverview = true;
    projectDetails = false;
    projectTldr = false;
  }

  function showProjectDetails() {
    projectOverview = false;
    projectDetails = true;
    projectTldr = false;
  }

  function showProjectTldr() {
    projectOverview = false;
    projectDetails = false;
    projectTldr = true;
  }

  function toggleCVButton() {
    isCVButtonActive = !isCVButtonActive;
  }

  // let navVisible = false;

  function typeWriter() {
    return new Promise((resolve) => {
      function typeNextChar() {
        if (i < txt.length) {
          bio += txt.charAt(i);
          i++;
          setTimeout(typeNextChar, speed);
        } else {
          // Typewriter effect is finished
          isBio = true;
          bioVisible = true; // Make bio visible as we type
          fadeInElements = true; // Set this to true when typewriter is done

          // Set activeSection to 'featured' only if 'about', 'contact', 'all', and 'wip' are not active
          if (
            !isAbout &&
            !isContact &&
            activeSection !== "all" &&
            activeSection !== "wip"
          ) {
            activeSection = "featured";
          }

          resolve();
        }
      }
      typeNextChar();
    });
  }

  let activeSubSection = ""; // For "Education", "Experience", "Skills"
  $: isSubSectionSelected =
    activeSubSection === "Education" ||
    activeSubSection === "Experience" ||
    activeSubSection === "Tools" ||
    activeSubSection === "Extras";

  let educationDetails = [
    // Array of education details
    {
      title: "PhD student in Computer Science",
      description: "Queen Mary University of London",
      date: "April 2021 - Present",
      img: "https://logosandtypes.com/wp-content/uploads/2020/07/queen-mary-university.svg",
    },
    {
      title: "MSc in Human-Centred Interactive Technologies",
      description: "The University of York",
      date: "Sept 2019 - Sept 2020",
      img: "https://pbs.twimg.com/profile_images/893420593055490048/e0mN-tuS_400x400.jpg",
    },
    {
      title: "BSc Multimedia Design",
      description: "Zayed University",
      date: "Sept 2014 - Dec 2018",
      img: "https://upload.wikimedia.org/wikipedia/en/2/27/Zayed_University_%28logo%29.png",
    },
    // ... other education details ...
  ];

  let experienceDetails = [
    // Array of experience details
    {
      title: "Business Program Manager Intern",
      description: "Microsoft",
      date: "Sept 2019 - Sept 2020",
      img: "https://upload.wikimedia.org/wikipedia/commons/2/25/Microsoft_icon.svg",
    },
    {
      title: "Marketing Intern",
      description: "Al Jalila Cultural Centre for Children",
      date: "Sept 2019 - Sept 2020",
      img: "https://scontent-lhr6-1.xx.fbcdn.net/v/t39.30808-6/312269375_488253426676229_7844776994549658165_n.jpg?_nc_cat=102&ccb=1-7&_nc_sid=efb6e6&_nc_ohc=sE9EuvRQB7oAX8HM-2Y&_nc_ht=scontent-lhr6-1.xx&oh=00_AfB5oN2a6AtErEEVbRO-zZBloKKgPrIBGgQAOe4DoZmlbA&oe=659B9783",
    },
    // ... other experience details ...
  ];

  let toolsDetails = [
    // Array of skills details
    {
      title: "Python",
      description: "",
      img: "https://upload.wikimedia.org/wikipedia/commons/c/c3/Python-logo-notext.svg",
    },
    {
      title: "Angular",
      description: "",
      img: "https://upload.wikimedia.org/wikipedia/commons/c/cf/Angular_full_color_logo.svg",
    },
    {
      title: "Svelte",
      description: "",
      img: "https://upload.wikimedia.org/wikipedia/commons/1/1b/Svelte_Logo.svg",
    },
    {
      title: "Tailwind CSS",
      description: "",
      img: "https://upload.wikimedia.org/wikipedia/commons/d/d5/Tailwind_CSS_Logo.svg",
    },
    {
      title: "Javascript",
      description: "",
      img: "https://upload.wikimedia.org/wikipedia/commons/9/99/Unofficial_JavaScript_logo_2.svg",
    },
    {
      title: "CSS",
      description: "",
      img: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1024px-CSS3_logo_and_wordmark.svg.png",
    },
    {
      title: "HTML",
      description: "",
      img: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/HTML5_logo_and_wordmark.svg/240px-HTML5_logo_and_wordmark.svg.png",
    },
    {
      title: "Figma",
      description: "",
      img: "https://upload.wikimedia.org/wikipedia/commons/3/33/Figma-logo.svg",
    },
    {
      title: "SPSS",
      description: "",
      img: "https://upload.wikimedia.org/wikipedia/en/1/1b/IBM_SPSS_v23.png",
    },
    {
      title: "After Effects",
      description: "",
      img: "https://upload.wikimedia.org/wikipedia/commons/c/cb/Adobe_After_Effects_CC_icon.svg",
    },
    {
      title: "Photoshop",
      description: "",
      img: "https://upload.wikimedia.org/wikipedia/commons/a/af/Adobe_Photoshop_CC_icon.svg",
    },
    {
      title: "Illustrator",
      description: "",
      img: "https://upload.wikimedia.org/wikipedia/commons/f/fb/Adobe_Illustrator_CC_icon.svg",
    },
    // {
    //   title: "Blender",
    //   description: "",
    //   img: "https://upload.wikimedia.org/wikipedia/commons/c/cb/Adobe_After_Effects_CC_icon.svg",
    // },
    // {
    //   title: "Photoshop",
    //   description: "",
    //   img: "https://upload.wikimedia.org/wikipedia/commons/a/af/Adobe_Photoshop_CC_icon.svg",
    // },
    // {
    //   title: "Illustrator",
    //   description: "",
    //   img: "https://upload.wikimedia.org/wikipedia/commons/f/fb/Adobe_Illustrator_CC_icon.svg",
    // },
    // { title: "", description: "", img: "" },

    // ... other skills details ...
  ];

  $: filteredDetails =
    activeSubSection === "Education"
      ? educationDetails
      : activeSubSection === "Experience"
        ? experienceDetails
        : activeSubSection === "Tools"
          ? toolsDetails
          : activeSubSection === "✨"
            ? extrasDetails
            : [];

  function toggleSection(section) {
    activeSection = section;
    isBio = section === "featured";
    isAbout = section === "about";
    isContact = section === "contact";
    activeSubSection = ""; // Reset the subsection when a new section is selected

    // Reset viewMode and selectedProject when navigating to a new section
    if (section !== "all") {
      viewMode = "all";
      selectedProject = null;
      projectOverview = false;
      projectDetails = false;
      projectTldr = false;
    }
  }
  function toggleSubSection(subSection) {
    activeSubSection = subSection;
    showParticles = subSection === "Extras"; // Show particles only when "Extras" is active
  }

  // Add a function to handle project selection
  function selectProject(project) {
    selectedProject = project;
    viewMode = "project";

    // Ensure Overview is active by default
    projectOverview = true;
    projectDetails = false;
    projectTldr = false;
  }

  // Define your particles configuration
  let particlesConfig = {
    fullScreen: {
      zIndex: 1,
    },
    particles: {
      number: {
        value: 0,
      },
      color: {
        value: ["#00FFFC", "#FC00FF", "#fffc00"],
      },
      shape: {
        type: "emoji",
        options: {
          emoji: {
            particles: {
              size: {
                value: 8,
              },
            },
            value: ["✨"],
          },
        },
      },
      opacity: {
        value: {
          min: 0,
          max: 1,
        },
        animation: {
          enable: true,
          speed: 2,
          startValue: "max",
          destroy: "min",
        },
      },
      size: {
        value: {
          min: 2,
          max: 4,
        },
      },
      links: {
        enable: false,
      },
      life: {
        duration: {
          sync: true,
          value: 5,
        },
        count: 1,
      },
      move: {
        enable: true,
        gravity: {
          enable: true,
          acceleration: 10,
        },
        speed: {
          min: 10,
          max: 20,
        },
        decay: 0.1,
        direction: "none",
        straight: false,
        outModes: {
          default: "destroy",
          top: "none",
        },
      },
      rotate: {
        value: {
          min: 0,
          max: 360,
        },
        direction: "random",
        move: true,
        animation: {
          enable: true,
          speed: 60,
        },
      },
      tilt: {
        direction: "random",
        enable: true,
        move: true,
        value: {
          min: 0,
          max: 360,
        },
        animation: {
          enable: true,
          speed: 60,
        },
      },
      roll: {
        darken: {
          enable: true,
          value: 25,
        },
        enable: true,
        speed: {
          min: 15,
          max: 25,
        },
      },
      wobble: {
        distance: 30,
        enable: true,
        move: true,
        speed: {
          min: -15,
          max: 15,
        },
      },
    },
    emitters: {
      life: {
        count: 1,
        duration: 0.1,
        delay: 0.4,
      },
      rate: {
        delay: 0.1,
        quantity: 150,
      },
      size: {
        width: 0,
        height: 0,
      },
    },
  };

  let onParticlesLoaded = (event) => {
    const particlesContainer = event.detail.particles;
  };

  void particlesInit(async (engine) => {
    // call this once per app
    // you can use main to customize the tsParticles instance adding presets or custom shapes
    // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
    // starting from v2 you can add only the features you need reducing the bundle size
    await loadFull(engine);
    // await loadSlim(engine);
  });

  onMount(async () => {
    await typeWriter(); // This will automatically set 'activeSection' to 'featured' after completion
    // Remove the direct setting of 'activeSection' here
  });

  function triggerConfetti() {
    confettiContainer.addEmitter({
      size: {
        width: 0,
        height: 0,
      },
      startCount: 20,
      rate: {
        delay: 0,
        quantity: 0,
      },
      life: {
        duration: 0.1,
        count: 1,
      },
    });
    console.log("confetti");
  }

  let projects = [
    {
      title: "The Impact of Onboarding Modalities in a Text Labeling Game",
      icon: "📄",
      description: "Conference Paper ∙ Quantitative Research",
      link: "https://ieeexplore.ieee.org/document/10333246",
      category: "featured",
      img: "",
    },
    {
      title: "Plasticless: Designing a Gamified App to Reduce Plastic Waste ",
      icon: "📱",
      description: "MSc Thesis ∙ UI/UX",
      link: "https://www.google.com",
      category: "all",
      img: "/images/plasticless.png",
    },
    {
      title: "Best Project C",
      description: "∙",
      category: "",
    },
    {
      title: "Best Project D",
      description: "This is another featured project description.",
      category: "",
    },
    {
      title: "Less Text, More Visuals",
      icon: "📄",
      description: "Workshop Paper ∙ Qualitative Research",
      linkText: "view ",
      link: "https://aclanthology.org/2022.games-1.3/",
      category: "featured",
    },
    {
      title: "University of York Wayfinding App",
      icon: "🧭",
      color: "#62A8FF",
      description: "UI Design ∙ UX Research",
      category: "all",
      vid: "https://player.vimeo.com/video/900567663?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
      overview:
        "This project involved creating a low fidelity prototype on Figma for an interactive University of York campus map, using a user-centered design lifecycle. This approach prioritised user input from the initial design stage to ensure the prototype met their needs. Final validation by users confirmed the prototype's effectiveness.",
    },
    {
      title: "Ailan's World: An Interactive Story",
      icon: "👩‍💻",
      description: "Game Dev ∙ UI Design",
      category: "all",
      img: "/images/ailan.gif",
      overview:
        "Ailan's World is an interactive story game developed in Adobe Animate with ActionScript 3, featuring a pixelated 8-bit art style and a simple color palette. The game's top-view map is inspired by Dubai's cityscape. All assets were initially crafted in Adobe Illustrator before being transferred to Adobe Animate. The game integrates various elements of Dubai's modern culture, offering an experience that UAE locals can easily recognise and relate to.",
      hasDetails: true,
    },
    {
      title: "The Dog That Loves Blue",
      icon: "📘",
      description: "Illustration ∙ Graphic Design",
      overview:
        "'The Dog That Loves Blue' is a picture book I illustrated as a freelance project. So far the book has sold over 2000 copies throughout the Middle East. It was also featured at the Emirates Literature Festival 2020.",
      category: "all",
      img: "/images/bluedog.webp",
      hasDetails: true,
    },
    {
      title: "Qudwa Exhibition",
      icon: "🎨",
      color: "#3837A4",
      description: "Videography ∙ Branding",
      category: "all",
      vid: "https://player.vimeo.com/video/388876134?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
      overview:
        "I filmed and edited videos using Adobe Premiere Pro for the Al Jalila Cultural Centre for Children's (AJCCC) gallery opening exhibition, 'Qudwa', at the Al Jalila Gallery. Additionally, I designed social media content and animations using Adobe After Effects for the promotion of this events on social media platforms",
      hasDetails: true,
    },
    {
      title: "43 Percent: Women in the UAE Workplace",
      icon: "📈",
      color: "#F5F5F5",
      description: "Videography ∙ Branding",
      category: "all",
      vid: "https://player.vimeo.com/video/900565153?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
      overview:
        "I led the video team for a class project where we developed a website highlighting the diverse roles of women in the UAE workplace. My role involved filming, editing, and managing video uploads to the '43 Percent' YouTube channel. In addition to working on videos, I designed the website's logo. This project culminated in an online website that showcased videos and articles about the topic",
    },
    {
      title: "Text labelling powered by AI-Generated Images",
      icon: "",
      description: "",
      category: "wip",
    },
    // {
    //   title: "gogglers.co",
    //   icon: "👀",
    //   description: "",
    //   category: "wip",
    // },
    // {
    //   title: "tomodoro.app",
    //   icon: "🍅",
    //   description: "",
    //   category: "wip",
    // },
  ];

  $: filteredProjects = projects.filter((p) => p.category === activeSection);

  let currentTheme = writable("default"); // Default theme

  // Define available themes
  const themes = ["default", "theme1", "theme2"];

  // Function to change theme
  function changeTheme() {
    currentTheme.update((current) => {
      const currentIndex = themes.indexOf(current);
      return themes[(currentIndex + 1) % themes.length];
    });
  }

  const theme1Colors = ["#ffc53f", "#366F6E", "#4A83CC", "#E64747"]; // Replace with your desired colors
  const theme2Colors = ["#32CD32", "#008000", "#7FFF00", "#00FA9A"]; // Replace with your desired colors

  // Function to get the class name based on the current theme
  function getClassName(baseClass, theme) {
    return `${baseClass} ${baseClass}-${theme}`;
  }

  // Function to get a random color based on the theme
  function getColorForTheme(theme) {
    if (theme === "theme1") {
      return theme1Colors[Math.floor(Math.random() * theme1Colors.length)];
    } else if (theme === "theme2") {
      return theme2Colors[Math.floor(Math.random() * theme2Colors.length)];
    } else {
      return "#0a4fff"; // Default color for default theme
    }
  }

  const baseClassNames = [
    "shape-blob",
    "shape-blob one",
    "shape-blob two",
    "shape-blob three",
  ];

  // Initial blobs creation
  let blobs = baseClassNames.map((baseClass, index) => {
    const theme = get(currentTheme); // Use get to read the value of the writable store
    const color = getColorForTheme(theme); // Get color based on theme
    return {
      id: index + 1,
      baseClass,
      className: getClassName(baseClass, theme),
      color,
      style: `left: ${Math.random() * 100}%; top: ${
        Math.random() * 100
      }%; position: relative;`,
    };
  });

  // Reactive statement to update blobs when the theme changes
  $: if ($currentTheme) {
    blobs = blobs.map((blob, index) => {
      // Generate new positions for each blob
      const newLeft = `${Math.random() * 100}%`;
      const newTop = `${Math.random() * 100}%`;

      const newColor = getColorForTheme($currentTheme);

      return {
        ...blob,
        className: getClassName(blob.baseClass, $currentTheme),
        color: newColor,
        // Update the style to include new positions and color
        style: `left: ${newLeft}; top: ${newTop}; position: absolute; background-color: ${newColor};`,
      };
    });
  }

  // Function to add blobs
  function addBlob() {
    // First, change the theme
    currentTheme.update((current) => {
      return current === "default" ? "theme1" : "default";
    });
    // Then, add a new blob with the updated theme
    const newId = blobs.length + 1;
    const baseClassName =
      baseClassNames[Math.floor(Math.random() * baseClassNames.length)];
    const theme = get(currentTheme);
    const newBlob = {
      id: newId,
      baseClass: baseClassName,
      className: getClassName(baseClassName, theme),
      color: getColorForTheme(theme),
      style: `left: ${Math.random() * 100}%; top: ${
        Math.random() * 100
      }%; position: absolute; background-color: ${getColorForTheme(theme)};`,
    };
    blobs = [...blobs, newBlob];
  }
</script>

{#if showParticles}
  <Particles
    id="tsparticles"
    class="your-class-names"
    options={particlesConfig}
    on:particlesLoaded={onParticlesLoaded}
  />
{/if}
<div class="blob-container">
  <div class="blob-c">
    {#each blobs as blob}
      <div class={blob.className} style={blob.style}></div>
    {/each}
  </div>

  <div class="flex top-0 left-0 right-0 text-white p-4">
    <div class="container mx-auto">
      <!-- {#if bioVisible === true} -->

      <nav class="flex justify-center">
        <div class="border-gray-200 py-2 px-2 rounded shadow blur-bg z-50">
          <button
            class:active={activeSection === "featured" ||
              activeSection === "all" ||
              activeSection === "wip"}
            on:click={() => toggleSection("featured")}
            class="bg-gray-100 text-gray-800 font-semibold m-1 py-2 px-4 border border-gray-300 rounded shadow"
            >Work</button
          >
          <button
            class:active={activeSection === "about" ||
              activeSection === "education" ||
              activeSection === "experience" ||
              activeSection === "tools" ||
              activeSection === "extras"}
            on:click={() => toggleSection("about")}
            class="bg-gray-50 hover:bg-gray-100 text-gray-800 font-semibold m-1 py-2 px-4 border border-gray-300 rounded shadow"
            >About</button
          >
          <button
            class:active={activeSection === "contact"}
            on:click={() => toggleSection("contact")}
            class="bg-gray-50 hover:bg-gray-100 text-gray-800 font-semibold m-1 py-2 px-4 border border-gray-300 rounded shadow"
            >Contact</button
          >
        </div>
      </nav>
      <!-- {/if} -->
    </div>
  </div>
  <!-- pages Section -->

  <div
    class="flex flex-1 flex-col overflow-y-scroll items-center justify-center shadow blur-bg mx-0 md:px-20 lg:px-32"
  >
  <div class="content-container ">
    {#if isBio && !activeSection}
      <div class="bio-container">
        <div
          class="relative p-5 text-center text-xl md:text-2xl lg:px-20 lg:mx-8"
        >
          <h2 id="bio" class="inline-flex items-center justify-center">
            {bio}
          </h2>
        </div>
      </div>
      {/if}
        {#if activeSection === "featured"}
          <div
            class="relative p-5 mx-5 text-center text-xl md:text-2xl lg:px-20 lg:mx-8"
          >
            <h2 id="bio" class="inline-flex items-center justify-center">
              {bio}
            </h2>
          </div>
        {/if}
    </div>

    {#if isAbout && !activeSubSection}
    <div class="overflow-visible">
      <div class="profile-img flex z-5">
        <img type="png" src="/images/profile-img.png" alt="profile pic" />
      </div>
    </div>
      <div
        class="relative p-5 mx-8 px-0 text-center text-xl md:text-2xl lg:px-20"
      >
        <!-- <h2 id="about" class="inline-flex items-center justify-center">
            {bio}
          </h2> -->
        <div
          class="text-base mx-1 px-1 my-5 md:text-lg md:mx-5 md:px-10 lg:px-20 xl:px-40"
        >
          <p>
            I am currently a PhD student at Queen Mary University of London
            where I focus on improving user engagement in data collection games
            for natural language processing. My research interests include
            co-designing with AI and exploring the use of text-to-image models
            for content generation in text labelling tasks.
          </p>
        </div>
      </div>
    {/if}

    {#if isContact}
      <div class="contact-container">
        <h2 id="contact" class="contact-text">
          get in touch on &nbsp;
          <a href="https://www.linkedin.com/in/fatima-althani" target="_blank">
            LinkedIn <span class="material-symbols-outlined text-xs"
              >open_in_new</span
            >
          </a>
          &nbsp; or drop me an &nbsp;
          <a href="mailto:timaalthani@gmail.com">
            email <span class="material-symbols-outlined text-xs">mail</span>
          </a>
        </h2>
      </div>
    {/if}


    <div
      class="{activeSection === 'featured'
        ? 'mt-20 animate-fade-in'
        : ''} relative p-5 mx-5 md:px-20 lg:mx-8"
    >
      <h2
        class="text-2xl font-bold mb-2 mt-12 {viewMode === 'project' &&
        selectedProject
          ? 'centered-heading'
          : ''}"
      >
        {#if viewMode === "project" && selectedProject}
          {selectedProject.title}
        {:else}
          {activeSection === "featured"
            ? "Featured"
            : activeSection === "all"
              ? "All"
              : activeSection === "wip"
                ? "In Progress..."
                : activeSection === "about"
                  ? activeSubSection
                  : ""}
        {/if}
      </h2>
      <!-- Check if the active section is "featured" -->
      {#if activeSection === "featured"}
      <div class="featured-section">
        <div
          class="class={fadeInElements
            ? 'animate-fade-in'
            : ''} flex flex-wrap gap-4"
        >
          {#each filteredProjects as project, index (project.title)}
            <!-- Added an index to the each loop -->
            <div
              class="mb-4 bg-white p-4 border border-gray-300 rounded shadow {index ===
                0 || index === 3
                ? 'flex-larger'
                : 'flex-smaller'}"
            >
              <h3 class="flex text-lg font-semibold">
                {#if project.img}
                  <img
                    src={project.img}
                    alt="project"
                    class="flex max-h-20 max-w-xs m-3"
                  />
                {/if}{project.icon}
                {project.title}
              </h3>
              <p>{project.description}</p>
              <a href={project.link} class="float-right" target="_blank"
                >view <span class="material-symbols-outlined text-xs">
                  open_in_new
                </span>
              </a>
            </div>
          {/each}
        </div>
      </div>
      {:else if viewMode === "all" && activeSection === "all"}
        <!-- Loop to display all projects -->
        {#each filteredProjects as project (project.title)}
          <div
            class="project-div mb-4 bg-white p-4 border border-gray-300 rounded shadow cursor-pointer"
            on:click={() => {
              selectProject(project);
              viewMode = "project";
            }}
            on:keydown={(e) => {
              if (e.key === "Enter") {
                selectedProject = project;
                viewMode = "project";
              }
            }}
          >
            <h3 class="text-lg font-semibold">
              {project.icon}
              {project.title}
            </h3>
            <p class="mt-2">{project.description}</p>
          </div>
        {/each}
      {:else if viewMode === "project" && selectedProject}
        <!-- Display the selected project details -->
        <div class="project-details">
          <!-- More details here -->
        </div>
        {#if projectOverview}
          <div class="project-overview">
            {#if selectedProject.img}
              <div
                class="mx-20 mb-5 flex justify-center md:mx-20 lg:mx-32"
              >
                <img src={selectedProject.img} alt={selectedProject.title} />
              </div>
            {/if}
            {#if selectedProject.vid}
              <div
                class="selected-project mx-20 mb-5 p-4 border border-gray-300 rounded shadow flex justify-center md:mx-20 lg:mx-32" style="background-color: {selectedProject.color};"
              >
                <iframe
                  src={selectedProject.vid}
                  frameborder="0"
                  allow="autoplay; fullscreen; picture-in-picture"
                  title="vimeo iframe"
                ></iframe>
              </div>
            {/if}
            <!-- <p>{selectedProject.description}</p> -->
            <div
              class="mx-0 p-4 md:mx-20 lg:mx-32"
            >
              <p class="text-s">{selectedProject.overview}</p>
            </div>
          </div>
        {:else if projectDetails}
          <div class="project-details-section">
            <p>details</p>

            <!-- Content for the project details -->
          </div>
        {:else if projectTldr}
          <div class="project-tldr">
            <p>tldr</p>
            <!-- Content for the TL;DR section -->
          </div>
        {/if}
      {:else if activeSection === "wip"}
        <div>
          {#each filteredProjects as project (project.title)}
            <div
              class="mb-4 bg-white p-4 border border-gray-300 rounded shadow"
            >
              <h3 class="text-lg font-semibold">
                {project.icon}
                {project.title}
              </h3>
              <p>{project.description}</p>
              <!-- Add more project details as needed -->
            </div>
          {/each}
        </div>
      {/if}
    </div>

    {#if isAbout}
      {#if activeSubSection === "Education" || activeSubSection === "Experience"}
      <div class="details-section">
        {#each filteredDetails as detail}
          <div class="mb-4 bg-white p-4 border border-gray-300 rounded shadow">
            <!-- Apply 'flex-col' here for vertical stacking -->
            <div class="detail flex flex-col items-center justify-between">
              <!-- Image container -->
              <div class="flex-shrink-0">
                <img
                  src={detail.img}
                  alt={detail.title}
                  class="mb-5 min-w-10 min-h-10 w-12 h-12 sm:min-w-12 sm:min-h-12 sm:w-16 sm:h-16 object-contain"
                />
              </div>
              <h3 class="text-center title">{detail.title}</h3>
              <p class="text-center description px-2">{detail.description}</p>
              <p class="text-right date">{detail.date}</p>
            </div>
          </div>
        {/each}
      </div>
      {/if}
      {#if isAbout && activeSubSection === "Tools"}
        <div class="tools-grid">
          {#each toolsDetails as tool}
            <div
              class="tool-item mb-4 bg-white p-4 border border-gray-300 rounded shadow flex items-center"
            >
              <div class="flex-shrink-0 mr-2">
                <!-- Prevent the image container from shrinking -->
                <img
                  src={tool.img}
                  alt={tool.title}
                  class="w-10 h-10 sm:w-12 sm:h-12 object-contain"
                />
              </div>
              <h3 class="flex-grow min-w-0">
                <!-- Allow text to grow and shrink as needed, with a minimum width -->
                <span
                  class="whitespace-nowrap overflow-hidden overflow-ellipsis"
                  >{tool.title}</span
                >
                <!-- Text overflow handling -->
              </h3>
              <!-- You can include the description if needed -->
              <!-- <p>{tool.description}</p> -->
            </div>
          {/each}
        </div>
      {/if}

      {#if activeSubSection === "Extras"}
        <div class="flex">
          <div>
            <iframe
              style="border-radius:12px"
              src="https://open.spotify.com/embed/track/3J2WUEn6oFN8eDPZov7w9I?utm_source=generator"
              width="100%"
              height="100"
              frameBorder="0"
              allowfullscreen=""
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
              title="Spotify player"
            ></iframe>
          </div>
        </div>
      {/if}
    {/if}
  </div>
</div>

<div class="flex sticky bottom-0 left-0 right-0 bg-gray-100 text-white p-4">
  <div class="add-blob-button items-center">
    <button on:click={addBlob} class="border-none">
      <div class="shape-blob-btn"></div>
    </button>
  </div>
  <!-- {#if bioVisible} -->
  <nav class="flex justify-center">
    {#if viewMode === "project"}
      <button
        on:click={() => (viewMode = "all")}
        class="bg-gray-100 hover:bg-gray-100 text-gray-800 m-1 py-2 px-4 border border-gray-300 rounded-3xl shadow"
        ><span class="material-symbols-outlined text-xs mx-5">
          arrow_back
        </span></button
      >
      <button
        on:click={showProjectOverview}
        class="{projectOverview
          ? 'active'
          : ''} bg-gray-100 hover:bg-gray-100 text-gray-800 m-1 py-2 px-4 border border-gray-300 rounded-3xl shadow"
        >Overview</button
      >
      <!-- {#if selectedProject.hasDetails === true}
      <button
        on:click={showProjectDetails}
        class="{projectDetails
          ? 'active'
          : ''} bg-gray-100 hover:bg-gray-100 text-gray-800 m-1 py-2 px-4 border border-gray-300 rounded-3xl shadow"
        >Details</button
      >
      {/if} -->
      <!-- <button
        on:click={showProjectTldr}
        class="{projectTldr
          ? 'active'
          : ''} bg-gray-100 hover:bg-gray-100 text-gray-800 m-1 py-2 px-4 border border-gray-300 rounded-3xl shadow"
        >TL;DR</button
      > -->
    {:else if isContact}
    <a class="cv-btn flex" href="/files/cv-fatima-althani-2024.pdf" download="cv">
    <button
        on:click={toggleCVButton}
        class:active={isCVButtonActive}
        class="flex bg-gray-100 hover:bg-gray-100 text-gray-800 m-1 py-2 px-4 border border-gray-300 rounded-3xl shadow"
      >
        CV<span class="material-symbols-outlined"> download </span>
      </button></a>
    {:else if isAbout}
      <!-- Buttons for About Section -->
      <button
        class:active={activeSubSection === "Education"}
        on:click={() => toggleSubSection("Education")}
        class="bg-gray-100 hover:bg-gray-100 text-gray-800 m-1 py-2 px-4 border border-gray-300 rounded-3xl shadow"
        >Education</button
      >

      <button
        class:active={activeSubSection === "Experience"}
        on:click={() => toggleSubSection("Experience")}
        class="bg-gray-100 hover:bg-gray-100 text-gray-800 m-1 py-2 px-4 border border-gray-300 rounded-3xl shadow"
        >Experience</button
      >

      <button
        class:active={activeSubSection === "Tools"}
        on:click={() => toggleSubSection("Tools")}
        class="bg-gray-100 hover:bg-gray-100 text-gray-800 m-1 py-2 px-4 border border-gray-300 rounded-3xl shadow"
        >Tools</button
      >

      <button
        class:active={activeSubSection === "Extras"}
        on:click={() => {
          toggleSubSection("Extras");
          triggerConfetti();
        }}
        class="bg-gray-100 hover:bg-gray-100 text-gray-800 m-1 py-2 px-4 border border-gray-300 rounded-3xl shadow"
        >✨</button
      >
    {:else}
      <button
        class="bg-gray-100 hover:bg-gray-100 text-gray-800 m-1 py-2 px-4 border border-gray-300 rounded-3xl shadow"
        class:active={activeSection === "featured"}
        on:click={() => (activeSection = "featured")}>Featured</button
      >
      <button
        class="bg-gray-100 hover:bg-gray-100 text-gray-800 m-1 py-2 px-4 border border-gray-300 rounded-3xl shadow"
        class:active={activeSection === "all"}
        on:click={() => (activeSection = "all")}>All</button
      >
      <button
        class="bg-gray-100 hover:bg-gray-100 text-gray-800 m-1 py-2 px-4 border border-gray-300 rounded-3xl shadow"
        class:active={activeSection === "wip"}
        on:click={() => (activeSection = "wip")}>WIP</button
      >
    {/if}
  </nav>
  <!-- {/if} -->
  <div class="add-blob-button"></div>
</div>

<style>
  .active,
  button:hover:not(.border-none) {
    background-color: #e5e7eb; /* Change this to your preferred highlight color */
    color: #0a4fff;
    border: 2px solid #0a4fff;
    /* Other styling as needed */
  }

  .active,
  .project-div:hover {
    background-color: #e5e7eb; /* Change this to your preferred hover background color */
    color: #0a4fff; /* Change this to your preferred hover text color */
    border: 2px solid #0a4fff; /* Change this to your preferred hover border color */
    /* Add any other hover styles you want here */
  }

  .active {
    background-color: #e5e7eb; /* Change this to your preferred highlight color */
    color: #0a4fff;
    border: 2px solid #0a4fff;
    /* font-weight: bold; */
  }
  .flex-larger {
    flex: 1.5; /* Takes up more space */
  }

  .flex-smaller {
    flex: 1; /* Takes up default space */
  }

  .flex-1 {
    flex: 1; /* Original styling */
  }

  .flex-2 {
    flex: 2; /* Increased flex size for when 'all' is selected */
  }
</style>
